export default __webpack_public_path__ + "static/media/computer.965521ab.png";